import { useEffect, useState } from "react";

/**
 * An object URL for a picked file — "" without one — revoked when the file
 * changes or the component goes. For showing an image that is not uploaded yet,
 * e.g. in the live preview of the public page, which is same-origin and can
 * therefore load it.
 */
export const useObjectUrl = (file) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!file) {
      setUrl("");
      return undefined;
    }
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file]);

  return url;
};
